import { useContext, useEffect, useState } from "react";
import { Context } from "../context/MainContext";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import { fetchUserEnrollments } from "../api/usersApi";

const MyTrainings = () => {
  const [loading, setLoading] = useState(false);
  const [enrollments, setEnrollments] = useState([]);
  const { user } = useContext(Context);

  const formattingOption = {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
  };

  useEffect(() => {
    const handleFetchEnrollments = async () => {
      if (user?.id) {
        setLoading(true);
        try {
          const res = await fetchUserEnrollments(user?.id, user?.accessToken);
          setEnrollments(res.data);
        } catch (err) {
          const message =
            (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            err.toString();
          toast.error(message);
        } finally {
          setLoading(false);
        }
      }
    };

    handleFetchEnrollments();
  }, [user?.id, user?.accessToken]);

  return (
    <div className="profile__main" style={{ padding: 30 }}>
      <div className="account__main__order">
        <h3>My Trainings</h3>

        <div className="account__main__order__table">
          <div
            className="account__main__order__table__body"
            style={{ minWidth: 800 }}
          >
            <div className="account__main__order__table__row head">
              <div
                style={{ width: "250px" }}
                className="account__main__order__table__row__head"
              >
                Program
              </div>
              <div
                style={{ width: "120px" }}
                className="account__main__order__table__row__head"
              >
                Duration
              </div>
              <div
                style={{ width: "120px" }}
                className="account__main__order__table__row__head"
              >
                Date
              </div>
              <div
                style={{ width: "200px" }}
                className="account__main__order__table__row__head"
              >
                Payment ID
              </div>
              <div
                style={{ width: "150px" }}
                className="account__main__order__table__row__head"
              >
                Payment Status
              </div>
              <div
                style={{ width: "150px" }}
                className="account__main__order__table__row__head"
              >
                Amount
              </div>
            </div>

            {loading ? (
              <Loading />
            ) : enrollments.length === 0 ? (
              <p style={{ padding: "20px 0", color: "#999" }}>
                No enrollments found.
              </p>
            ) : (
              enrollments.map((enrollment) => (
                <div
                  key={enrollment.id}
                  className="account__main__order__table__row"
                >
                  <div
                    style={{ width: "250px" }}
                    className="account__main__order__table__row__data"
                  >
                    {enrollment?.courseName}
                  </div>
                  <div
                    style={{ width: "120px" }}
                    className="account__main__order__table__row__data"
                  >
                    {enrollment?.period}
                  </div>
                  <div
                    style={{ width: "120px" }}
                    className="account__main__order__table__row__data"
                  >
                    {enrollment?.createdAt?.slice(0, 10)}
                  </div>
                  <div
                    style={{ width: "200px" }}
                    className="account__main__order__table__row__data"
                  >
                    {enrollment?.paymentId}
                  </div>
                  <div
                    style={{ width: "150px" }}
                    className="account__main__order__table__row__data"
                  >
                    <p
                      className={`account__main__order__table__row__data__status ${
                        enrollment?.paymentStatus === "Success"
                          ? "status--success"
                          : enrollment?.paymentStatus === "Failed"
                            ? "status--failed"
                            : "status--initiated"
                      }`}
                    >
                      {enrollment?.paymentStatus === "Initiated"
                        ? "Pending"
                        : enrollment?.paymentStatus}
                    </p>
                  </div>
                  <div
                    style={{ width: "150px" }}
                    className="account__main__order__table__row__data"
                  >
                    {enrollment?.amount?.toLocaleString(
                      "en-NG",
                      formattingOption,
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTrainings;
